import type { MembershipTypeReference } from '@/types/member'
import { pushToDataLayer } from '@/utils/gtm'

interface userPlusMemberProps {
  userId: number
  memberId: number
  membershipType: MembershipTypeReference
}

interface userProps {
  userId: number
}

export const directEasyActivateEvent = ({ userId, memberId, membershipType }: userPlusMemberProps): void => pushToDataLayer({
  event: 'member_activate_immediately',
  event_action: 'inactive_member_reactivated',
  userId,
  memberId,
  membershipType
})

export const activateFreeSocksEvent = ({ userId }: userProps): void => pushToDataLayer({
  event: 'user_free_socks',
  event_action: 'free_socks_activated',
  userId
})

export const copyLoyaltyInviteLinkEvent = ({ userId }: userProps): void => pushToDataLayer({
  event: 'loyalty_invite_link',
  event_action: 'referral_code_copied',
  userId
})

export const copyWomenLoyaltyInviteLinkEvent = ({ userId }: userProps): void => pushToDataLayer({
  event: 'women_loyalty_invite_link',
  event_action: 'women_referral_code_copied',
  userId
})

export const shareLoyaltyLinkThroughWhatsappEvent = ({ userId }: userProps): void => pushToDataLayer({
  event: 'loyalty_invite_whatsapp',
  event_action: 'referral_code_whatsapp',
  userId
})

type TrackCancelFlowProps = userPlusMemberProps & {
  flowStepCount: number
  flowStep: string
  flowAction: string
  flowDetail?: string | number
}

export const trackCancelFlow = ({ userId, memberId, membershipType, flowStepCount, flowStep, flowAction, flowDetail }: TrackCancelFlowProps):void => pushToDataLayer({
  event: 'cancelFlow',
  userId,
  memberId,
  membershipType,
  flowStepCount,
  flowStep,
  flowAction,
  ...(flowDetail ? { flowDetail } : {})
})

export const identifyUserEvent = ({ otaUserId }: { otaUserId: string }): void => pushToDataLayer({
  event: 'identify_user',
  otaUserId
})

export const downloadWithdrawalForm = (): void => pushToDataLayer({
  event: 'download_withdrawal_form'
})
